export class Loader {
  constructor(parentelement) {
    this.parentelement = parentelement;
    this.svgtext = '<svg version="1.1" id="Layer_1" class="loader" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 53.2 50" style="enable-background:new 0 0 53.2 50;" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#00843D;}.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFD100;}</style>';
    this.svgtext += '<g><path class="st0" d="M26.6,8.5C28.5,5.2,30.9,3,34,1.8c1.9-0.8,3.8-1.1,5.5-1c1.9,0.1,4,0.3,6,1.3c2.1,1.1,3.6,2.8,4.7,4.5 c1.1,1.6,1.8,3.6,2.1,6.1c0.3,2.5,0.1,4.6-0.5,6.5c-0.6,1.8-1.4,3.5-2.4,5.1c-0.9,1.6-2.2,3.1-3.7,4.7c-0.9,0.9-2.4,2.3-4.4,4.1 c-0.9,0.8-2.4,2.1-4.5,3.9c-1.8,1.5-3.1,2.7-4,3.5c-2.4,2.2-4.5,4.7-6.3,7.4c-1.7-2.7-3.8-5.2-6.2-7.4c-0.9-0.8-2.2-2-4-3.5 c-1.5-1.3-3-2.6-4.4-3.9c-2-1.8-3.5-3.2-4.4-4.1c-1.5-1.5-2.8-3.1-3.7-4.7c-1-1.6-1.8-3.3-2.4-5.1c-0.6-1.8-0.8-4-0.5-6.5 c0.3-2.5,1-4.5,2.1-6.1c1.1-1.6,2.2-3,4.4-4.1c2-1,4.4-1.6,6.3-1.7c1.8-0.1,3.6,0.3,5.5,1C22.3,3,24.8,5.2,26.6,8.5"/>';
    this.svgtext += '<path class="st1" d="M14.2,1.6c-0.2,0-0.3,0-0.5,0c-1.9,0.1-4.2,0.7-6,1.6c-1.9,1-3,2.2-4.1,3.8c-1,1.5-1.7,3.4-1.9,5.8 c-0.3,2.3-0.1,4.4,0.5,6.1c0.6,1.7,1.4,3.4,2.3,5c0.9,1.5,2.1,3.1,3.6,4.5c0.8,0.9,2.2,2.2,4.4,4.1c0.9,0.8,2.3,2.1,4.4,3.8 c1.8,1.5,3.1,2.7,4,3.5c2.1,2,4.1,4.2,5.7,6.6c1.7-2.4,3.6-4.6,5.7-6.6c0.9-0.9,2.3-2.1,4-3.5c1.5-1.3,3-2.5,4.4-3.8 c1.9-1.7,3.4-3.1,4.4-4.1c1.5-1.5,2.7-3.1,3.6-4.5c0.9-1.6,1.7-3.2,2.3-5c0.6-1.7,0.8-3.8,0.5-6.1c-0.3-2.4-0.9-4.3-1.9-5.8 c-1.3-2-2.8-3.3-4.4-4.2c-1.8-1-3.8-1.2-5.6-1.2c-0.1,0-0.3,0-0.5,0c-1.6,0-3.2,0.3-4.8,1c-2.9,1.1-5.3,3.3-7,6.4l-0.7,1.2 l-0.7-1.2c-1.8-3.1-4.1-5.2-7-6.4C17.3,1.9,15.7,1.6,14.2,1.6z M26.6,49.3l-0.7-1c-1.7-2.7-3.8-5.1-6.1-7.3c-0.9-0.8-2.2-2-4-3.5 c-1.5-1.3-3-2.6-4.5-3.9c-2.2-1.9-3.6-3.2-4.5-4.1c-1.5-1.6-2.8-3.2-3.8-4.8c-1-1.7-1.8-3.4-2.4-5.3c-0.7-2-0.9-4.2-0.6-6.8 c0.3-2.6,1-4.8,2.2-6.5C3.5,4.4,4.8,3,7,1.8c1.9-1,4.5-1.7,6.6-1.8c1.9-0.1,3.9,0.3,5.9,1c2.9,1.1,5.3,3.1,7.1,5.9 c1.8-2.8,4.2-4.8,7.1-5.9c2-0.8,3.9-1.1,5.9-1.1c2,0.1,4.2,0.3,6.3,1.4c1.9,1,3.5,2.5,5,4.7c1.2,1.7,1.9,3.9,2.2,6.5 c0.3,2.6,0.1,4.9-0.6,6.8c-0.7,1.9-1.5,3.6-2.4,5.3c-0.9,1.6-2.2,3.2-3.8,4.8c-1,1-2.5,2.4-4.5,4.1c-1,0.9-2.5,2.2-4.5,3.9 c-1.7,1.4-3,2.6-4,3.5c-2.4,2.2-4.4,4.6-6.1,7.3L26.6,49.3L26.6,49.3z"/> </g>';
    this.svgtext += '</svg>';
  }
  checkparent() {
    return this.parentelement instanceof HTMLElement;
  }
  appendLoader() {
    if (this.checkparent()) {
      let loader = document.createElement('span');
      loader.className = 'rbt-loader';
      loader.innerHTML = this.svgtext;
      this.parentelement.appendChild(loader);
    }
  }
  doLoader() {
    if (this.checkparent()) {
      let loader = document.createElement('span');
      loader.className = 'rbt-loader';
      loader.innerHTML = this.svgtext;
      this.parentelement.innerHTML = '';
      this.parentelement.appendChild(loader);
    }
  }
  removeLoader() {
    if (this.checkparent()) {
      let loader = this.parentelement.querySelector('span.rbt-loader');
      if (loader) loader.remove();
    }
  }
}

export const mosViewMore = (e) => {
  e.preventDefault();
  let content = e.target.closest('.content');
  let expander = content.querySelector('.expander');
  let expanderContent = content.querySelector('.expander-content');
  if (expander.classList.contains('active')) {
    expander.classList.remove('active');
    expanderContent.classList.add('active')
    expanderContent.style.maxHeight = expanderContent.scrollHeight + 'px';
  } else {
    expander.classList.add('active');
    expanderContent.style.maxHeight = null;
  }
}

export const viewMore = (e) => {
  e.preventDefault();
  let content = e.target.closest('.entry-item-content');
  let expander = content.querySelector('.expander');
  let expanderContent = content.querySelector('.expander-content');
  if (expander.classList.contains('active')) {
    expander.classList.remove('active');
    expanderContent.classList.add('active')
    expanderContent.style.maxHeight = expanderContent.scrollHeight + 'px';
  } else {
    expander.classList.add('active');
    expanderContent.style.maxHeight = null;
  }
}
/* @Todo: move this to parent theme */
export const saveGHContent = (e) => {
  e.preventDefault();
  let item_id = e.target.dataset.contentItem;
  let item_type = e.target.dataset.contentType;
  let nonce = rbtQD.nonce;
  let button = e.target;
  button.innerHTML = '<svg class="loading-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="20" height="20"><circle cx="50" cy="50" r="45" stroke="#fff" stroke-width="5" fill="none" stroke-dasharray="283" stroke-dashoffset="280"><animateTransform attributeName="transform" attributeType="XML" type="rotate" from="0 50 50" to="360 50 50" dur="1s" repeatCount="indefinite"/></circle></svg> Saving...';
  let url = rbtQD.apiBase + 'save_content/' + item_type + '/' + item_id;
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': nonce
    }
  })
    .then(response => response.json())
    .then(data => {
      if (data.link) {
        // Update button to 'Student Saved: Apply Now' and change href
        button.href = data.link;
        button.removeAttribute('onclick');
        button.innerHTML = data.message;
        button.parentElement.classList.add('activated');
        let footer = button.closest('.item-footer');
        let apply = footer.querySelector('.apply');
        //remove the redundant apply button
        if (apply) apply.remove();
      } else {
        // Handle case where link is not in the response
        button.innerHTML = 'Error saving post';
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

export const saveStudent = (e) => {
  e.preventDefault();
  let student_id = e.target.dataset.student
  let url = rbtQD.apiBase + 'save_student/' + student_id;
  let nonce = rbtQD.nonce;

  // Add animated SVG and change button text to 'Saving...'
  let button = e.target;
  button.innerHTML = '<svg class="loading-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="20" height="20"><circle cx="50" cy="50" r="45" stroke="#fff" stroke-width="5" fill="none" stroke-dasharray="283" stroke-dashoffset="280"><animateTransform attributeName="transform" attributeType="XML" type="rotate" from="0 50 50" to="360 50 50" dur="1s" repeatCount="indefinite"/></circle></svg> Saving...';

  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': nonce
    }
  })
    .then(response => response.json())
    .then(data => {
      if (data.link) {
        // Update button to 'Student Saved: Apply Now' and change href
        button.href = data.link;
        button.removeAttribute('onclick');
        button.innerHTML = data.message;
        button.parentElement.classList.add('activated');
        let footer = button.closest('.card-footer');
        let apply = footer.querySelector('.apply');
        //remove the redundant apply button
        if (apply) apply.remove();
      } else {
        // Handle case where link is not in the response
        button.innerHTML = 'Error saving student';
      }

    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

export const accordionClick = (e) => {
  e.preventDefault();
  let title = e.target.classList.contains('accordion-title') ? e.target : e.target.closest('.accordion-title');
  let panel = title.nextElementSibling;
  title.classList.toggle('active');
  if (panel.style.maxHeight) {
    panel.style.maxHeight = null;
    panel.classList.remove('active');
  } else {
    panel.classList.add('active'); /* wait for the padding to animate */
    setTimeout(() => {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }, 1);

  }
}